import React from "react";
import MyAssessment from "../Components/My-assessment/myAssessment";
import SelectTest from "../Components/Test-library/Test-results/selectTest";
import AddQuestion from "../Components/Test-library/Test-results/addQuestion";
import InvitePreview from "../Components/Test-library/Test-results/invitePreview";
import CreateQuestion from "../Components/Test-library/Test-results/createQuestion";
import CandidateTest from "../Components/Candidate-Test/candidateTest";
import TestReport from "../Components/My-assessment/test-report";
import Reports from "../Components/Reports/reports";
import Users from "../Components/Users/user";
import Settings from "../Components/Settings/settings";
import RegisterTest from "../Components/Candidate-Test/registerTest";
import Accounts from "../Components/Settings/profile";
import TanentUsers from "../Components/TanentUser/tanentUsers";
import Main from "../utils/CodeEditor/main";
import SelectCodingTest from "../Components/Test-library/selectCodingTest";
import SelectDatabaseTest from "../Components/Test-library/SelectDatabaseTest";
import CreateCodingQuestion from "../Components/CreateCodingQuestion/createCodingQuestion";
import CreateCodeText from "../Components/CreateCodingQuestion/createCodeText";
import GappeoTest from "../Components/Gappeo Tests/gappeoTest";
import MyQuestions from "../Components/My-Questions/myQuestions";
import MyTests from "../Components/My-tests/mytests";
import AssessmentReport from "../Components/My-assessment/assessmentReport";
import Jobs from "../Components/JobPosting/jobs";
// import CreateJob from "../Components/JobPosting/createJob";
import CreateJob from "../Components/CreateJob/createJob";
import CandidateProfile from "../Components/JobPosting/candidateProfile";
import VoiceInterviewsReport from "../Components/Interview-result/voiceInterviewsReport";
import VideoInterviewsReport from "../Components/Interview-result/videoInterviewsReport";
import VideoInterview from "../Components/Video-Interview/videoInterview";
import EditJob from "../Components/JobPosting/editJob";
import CandidateUpload from "../Components/Candidate-Upload/candidateUpload";
import Dashboard from "../Components/Home/Dashboard";
import Livefeed from "../Components/Home/Livefeed";
import JobTabs from "../Components/JobPosting/jobTabs";
import Candidates from "../Components/JobPosting/candidates";
import JobDetails from "../Components/JobPosting/jobDetails";
import JobSettings from "../Components/JobPosting/jobSettings";
import Automation from "../Components/JobPosting/automation";
import ApiKeys from "../Components/Settings/apiKeys";
import Companies from "../Components/Settings/companies";
import CompanyMembers from "../Components/Settings/companyMembers";
import CandidateManagement from "../Components/Candidates/candidateManagement";
const TestLibrary = React.lazy(() => import("../Components/Home/Home"))

const RouteItems = [
    { path: "/home", component: <TestLibrary />, layout: "mainLayout", title: "Home", letter: 'H' },
    { path: '/assessments', component: <MyAssessment />, layout: 'mainLayout', title: 'Assessments', letter: 'A' },
    { path: '/assessments-report', component: <AssessmentReport />, layout: 'mainLayout', title: 'Assessments Report', letter: 'A' },
    { path: '/gappeo-tests', component: <GappeoTest />, layout: 'mainLayout', title: 'Gappeo Test', letter: 'G' },
    { path: '/reports', component: <Reports />, layout: 'mainLayout', title: 'Reports', letter: 'R' },
    { path: '/test-report', component: <TestReport />, layout: 'mainLayout', title: 'Test Reports', letter: 'T' },
    { path: '/plan', component: <Settings />, layout: 'mainLayout', title: 'Settings', letter: 'S' },
    { path: '/users', component: <Users />, layout: 'mainLayout', title: 'Users', letter: 'U' },
    { path: '/my-questions', component: <MyQuestions />, layout: 'mainLayout', title: 'My Questions', letter: 'Q' },
    { path: '/select-coding-test', component: <SelectCodingTest />, layout: 'mainLayout', title: 'Select Database Test', letter: 'S' },
    { path: '/select-database-test', component: <SelectDatabaseTest />, layout: 'mainLayout', title: 'Select Coding Test', letter: 'S' },
    { path: '/home/select-test', component: <SelectTest />, layout: 'mainLayout', title: 'Create Assessment', letter: 'H' },
    { path: '/home/add-question', component: <AddQuestion />, layout: 'mainLayout', title: 'Add Questions', letter: 'H' },
    { path: '/home/invite-preview', component: <InvitePreview />, layout: 'mainLayout', title: 'Invite Perview', letter: 'H' },
    { path: '/create', component: <CreateQuestion />, layout: 'mainLayout', title: 'Create Questions', letter: 'C' },
    { path: '/create-coding-question', component: <CreateCodingQuestion />, layout: 'mainLayout', title: 'Create Coding Questions', letter: 'C' },
    // { path: '/create-database-question', component: <CreateDatabaseQuestions />, layout: 'mainLayout', title: 'Create Database Questions', letter: 'C' },
    { path: '/profile', component: <Accounts />, layout: 'mainLayout', title: 'Profile', letter: 'P' },
    { path: '/tanents', component: <TanentUsers />, layout: 'mainLayout', title: 'User', letter: 'U' },
    { path: '/add-text', component: <CreateCodeText />, layout: 'mainLayout', title: 'Create code Text', letter: 'C' },
    { path: '/jobs', component: <Jobs />, layout: 'mainLayout', title: 'Jobs', letter: 'J' },
    { path: '/candidates-management', component: <CandidateManagement />, layout: 'mainLayout', title: 'Candidates', letter: 'C' },
    { path: '/jobs/createjob', component: <CreateJob />, layout: 'mainLayout', title: 'Create Job', letter: 'J' },
    { path: '/jobs/editJob', component: <EditJob />, layout: 'mainLayout', title: 'Edit Job', letter: 'J' },
    {
        path: "/jobs/:jobId", component: <JobTabs />, layout: "mainLayout",
        children: [
            { path: "candidates", component: <Candidates />, },
            { path: "details", component: <JobDetails />, },
            { path: "settings", component: <JobSettings />, },
            { path: "automation", component: <Automation />, },
        ],
    },
    { path: '/jobs/:jobId/candidates/:candidateId', component: <CandidateProfile />, layout: 'mainLayout', title: 'Candidates Profile', letter: 'J' },
    { path: '/voice-interviews-report', component: <VoiceInterviewsReport />, layout: 'mainLayout', title: 'Voice Interview', letter: 'V' },
    { path: '/video-interviews-report', component: <VideoInterviewsReport />, layout: 'mainLayout', title: 'Video Interview', letter: 'V' },
    { path: '/dashboard', component: <Dashboard />, layout: 'mainLayout', title: 'Dashboard', letter: 'D' },
    { path: '/dashboard/live-feed', component: <Livefeed />, layout: 'mainLayout', title: 'Live Feed', letter: 'L' },
    { path: '/keys', component: <ApiKeys />, layout: 'mainLayout', title: 'KPI Keys', letter: 'A' },
    { path: '/companies', component: <Companies />, layout: 'mainLayout', title: 'Companies', letter: 'C' },
    { path: '/company-members', component: <CompanyMembers />, layout: 'mainLayout', title: 'Company Members', letter: 'C' },

    { path: '/candidate-test/:token', component: <CandidateTest />, layout: 'candidate-layout' },
    { path: '/candidate-invite-test/:token', component: <RegisterTest />, layout: 'candidate-layout' },
    { path: '/coding-test', component: <Main />, layout: 'candidate-layout' },
    { path: '/my-tests', component: <MyTests />, layout: 'mainLayout', title: 'My Test', letter: 'T' },
    { path: '/video-call/:token', component: <VideoInterview />, layout: 'videoInterview-layout' },
    { path: '/jobs/:jobId/apply', component: <CandidateUpload />, layout: 'candidate-upload' },


]

export default RouteItems;